<template>
  <v-row>
    <v-col
      class="pb-1"
      cols="12"
      no-gutters
      v-for="(item, index) in item"
      :key="index"
    >
      <v-card class="mx-auto shadow rounded-lg" color="#FFF" dark>
        <div class="notification">
          <div class="title-notif">
            <h3 class="text-title">{{ $t(item.type) }}</h3>
            <span>{{ item.date }}</span>
          </div>
          <div class="mt-1 clm-view">
            <span>{{ item.content_msg }}</span>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
  
<script>  
  export default {
    name: 'ListOfNotification',
    props: ["item"],
  };
</script>
  
<style scoped>

.notification {
  padding: 1rem;
  color: #000;
}

.title-notif {
  display: flex;
  justify-content: space-between;
}

.text-title {
  text-transform: capitalize;
}

.clm-view {
  display: flex;
  flex-direction: column;
}
</style>